class OdooJsonRpcService {
    constructor(config) {
        this.url = config.url;
        this.db = config.db;
        this.username = config.username;
        this.password = config.password;
        this.uid = null;
    }

    async login() {
        const response = await fetch(`${this.url}/jsonrpc`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                jsonrpc: "2.0",
                method: "call",
                params: {
                    service: "common",
                    method: "login",
                    args: [this.db, this.username, this.password]
                },
                id: 1
            })
        });

        const data = await response.json();
        if (data.result) {
            this.uid = data.result;
                // console.log("Login successful. UID:", this.uid);
            return this.uid;
        } else {
            throw new Error("Login failed");
        }
    }

    async fetchProducts() {
        if (!this.uid) {
            throw new Error('Not authenticated. Call login() first.');
        }

        const response = await fetch(`${this.url}/jsonrpc`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                jsonrpc: "2.0",
                method: "call",
                params: {
                    service: "object",
                    method: "execute_kw",
                    args: [
                        this.db,
                        this.uid,
                        this.password,
                        'product.product',
                        'search_read',
                        [[]],
                        {
                            'fields': ['id', 'name', 'list_price', 'default_code', 'categ_id'],
                            'limit': 100
                        }
                    ]
                },
                id: 2
            })
        });

        const data = await response.json();
        if (data.result) {
            console.log(`✅ Fetched ${data.result.length} products`);
            return data.result;
        } else {
            throw new Error("Failed to fetch products");
        }
    }

    // async fetchProductsByCategories(categoryIds = []) 
    // async fetchProductsByCategories(categoryIds = []) 
    async fetchProductsByCategories() 
    {
            if (!this.uid) {
                throw new Error('Not authenticated. Call login() first.');
            }
            /*.  
                Earthing Electrode.  4
            BackFill Compound(s).  5
             Accessories.  9
              SLPR.    12
                    EPCC 21.  
               
                   
                    
                    Earthing Electrodes.   19
                    
            */
            let categoryIds = [5,4,9,12,21];  // 8 for clp 
            const domain = categoryIds.length > 0 ? [['categ_id', 'in', categoryIds]] : [];

            const response = await fetch(`${this.url}/jsonrpc`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    jsonrpc: "2.0",
                    method: "call",
                    params: {
                        service: "object",
                        method: "execute_kw",
                        args: [
                            this.db,
                            this.uid,
                            this.password,
                            'product.product',
                            'search_read',
                            [domain],
                            {
                                fields: ['id', 'name', 'list_price', 'default_code', 'categ_id'],
                                limit: 100
                            }
                        ]
                    },
                    id: 2
                })
            });

            const data = await response.json();
            if (data.result) {
                console.log(`✅ Fetched ${data.result.length} products`);
                return data.result;
            } else {
                throw new Error("Failed to fetch products");
            }
    }


    // async fetchCustomers(creatorId) {
    async fetchCustomers() {
        if (!this.uid) {
            throw new Error('Not authenticated. Call login() first.');
        }
        // const domain = creatorId ? [['quote_creator_id', '=', creatorId]] : [];
        //const domain =  [['quote_creator_id', '=', 5]];
        let quoteCreatorId=122; //5
        let domain = [];
            if (quoteCreatorId) {
                // domain = ['|', ['is_company', '=', true], ['quote_creator_id', '=', quoteCreatorId]];
                domain = [['is_company', '=', true], ['quote_creator_id.id', '=', quoteCreatorId]];
            } else {
                domain = [['is_company', '=', true]];
            }
            //  domain = [['is_company', '=', true]];
                console.log('Using domain:', JSON.stringify(domain));
        const response = await fetch(`${this.url}/jsonrpc`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                jsonrpc: "2.0",
                method: "call",
                params: {
                    service: "object",
                    method: "execute_kw",
                    args: [
                        this.db,
                        this.uid,
                        this.password,
                        'res.partner',
                        'search_read',
                        //[[]],
                        [domain],
                        {
                            'fields': ['id', 'name', 'email', 'phone', 'mobile','street','street2','city','state_id','country_id','zip','is_company','customer_rank','quote_creator_id'],
                            'limit': 100
                        }
                    ]
                },
                id: 2
            })
        });

        const data = await response.json();
        if (data.error) {
        console.error('Odoo Error:', data.error);
        throw new Error(`Odoo Error: ${data.error.data.message}`);
    }
        if (data.result) {
            console.log(`✅ Fetched ${JSON.stringify(data.result)} Customers`);
            console.log(`✅ Fetched ${data.result.length} Customers`);
            return data.result;
        } else {
            throw new Error("Failed to fetch customers");
        }
    }

    async getVersion() {
        const response = await fetch(`${this.url}/jsonrpc`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                jsonrpc: "2.0",
                method: "call",
                params: {
                    service: "common",
                    method: "version",
                    args: []
                },
                id: 0
            })
        });

        const data = await response.json();
        if (data.result) {
            //    console.log('🔧 Odoo version:', data.result);
            return data.result;
        } else {
            throw new Error("Failed to get version");
        }
    }



    isAuthenticated() {
        return this.uid !== null;
    }

    logout() {
        this.uid = null;
         console.log('👋 Logged out');
    }


    //// New one added 
    async jsonRpc(endpoint, method, params = {}) {
    const payload = {
      jsonrpc: '2.0',
      method: 'call',
      params: params,
      id: Math.floor(Math.random() * 1000000)
    };

    const response = await fetch(`${this.url}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    const result = await response.json();
    
    if (result.error) {
      throw new Error(`Odoo RPC Error: ${result.error.message}`);
    }
    
    return result.result;
  }

  // Authenticate with Odoo
  async authenticate() {
    try {
      const result = await this.jsonRpc('/web/session/authenticate', 'call', {
        db: this.database,
        login: this.username,
        password: this.password
      });
      
      if (result && result.uid) {
        this.uid = result.uid;
        this.sessionId = result.session_id;
        return true;
      }
      throw new Error('Authentication failed');
    } catch (error) {
      console.error('Authentication error:', error);
      throw error;
    }
  }

  // Search and read records (the missing function)
//   async searchRead(model, domain = [], fields = [], options = {}) {
//     if (!this.uid) {
//     //   await this.authenticate();
//     throw new Error('Not authenticated. Call login() first.');
//     }

//     try {
//       const params = {
//         model: model,
//         method: 'search_read',
//          jsonrpc: "2.0",
//         args: [domain],
//         kwargs: {
//           fields: fields,
//           limit: options.limit || false,
//           offset: options.offset || 0,
//           order: options.order || 'id DESC'
//         }
//       };

//       const result = await this.jsonRpc('/web/dataset/call_kw', 'call', params);
//       return result || [];
//     } catch (error) {
//       console.error(`Error in searchRead for model ${model}:`, error);
//       throw error;
//     }
//   }

async searchRead(model, domain = [], fields = [], limit = false, offset = 0, order = 'id DESC') {
    if (!this.uid) {
        throw new Error('Not authenticated. Call login() first.');
    }

    try {
        const response = await fetch(`${this.url}/jsonrpc`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                jsonrpc: "2.0",
                method: "call",
                params: {
                    service: "object",
                    method: "execute_kw",
                    args: [
                        this.db,
                        this.uid,
                        this.password,
                        model,
                        'search_read',
                        [domain],
                        {
                            fields: fields,
                            limit: limit,
                            offset: offset,
                            order: order
                        }
                    ]
                },
                id: Math.floor(Math.random() * 1000000000)
            })
        });

        const result = await response.json();

        if (result.error) {
            console.error('Odoo RPC Error:', result.error);
            throw new Error(result.error.message);
        }

        return result.result || [];
    } catch (error) {
        console.error(`Error in searchRead for model ${model}:`, error);
        throw error;
    }
}

  // Alternative: separate search and read methods
  async search(model, domain = [], limit = false, offset = 0, order = 'id DESC') {
    if (!this.uid) {
        throw new Error('Not authenticated. Call login() first.');
    }

    try {
        const response = await fetch(`${this.url}/jsonrpc`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                jsonrpc: "2.0",
                method: "call",
                params: {
                    service: "object",
                    method: "execute_kw",
                    args: [
                        this.db,
                        this.uid,
                        this.password,
                        model,
                        'search',
                        [domain],
                        {
                            limit: limit,
                            offset: offset,
                            order: order
                        }
                    ]
                },
                id: Math.floor(Math.random() * 1000000000)
            })
        });

        const result = await response.json();

        if (result.error) {
            console.error('Odoo RPC Error:', result.error);
            throw new Error(result.error.message);
        }

        return result.result || [];
    } catch (error) {
        console.error(`Error in search for model ${model}:`, error);
        throw error;
    }
}

  async read(model, ids, fields = []) {
    if (!this.uid) {
        throw new Error('Not authenticated. Call login() first.');
    }

    try {
        const response = await fetch(`${this.url}/jsonrpc`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                jsonrpc: "2.0",
                method: "call",
                params: {
                    service: "object",
                    method: "execute_kw",
                    args: [
                        this.db,
                        this.uid,
                        this.password,
                        model,
                        'read',
                        [ids],
                        {
                            fields: fields
                        }
                    ]
                },
                id: Math.floor(Math.random() * 1000000000)
            })
        });

        const result = await response.json();

        if (result.error) {
            console.error('Odoo RPC Error:', result.error);
            throw new Error(result.error.message);
        }

        return result.result || [];
    } catch (error) {
        console.error(`Error in read for model ${model}:`, error);
        throw error;
    }
    }

    /**
 * Creates a new record in a specified model.
 * @param {string} model The model to create the record in (e.g., 'res.partner').
 * @param {object} data An object of key-value pairs for the new record.
 * @returns {Promise<number>} The ID of the newly created record.
 */
async create(model, data) {
    if (!this.uid) {
        throw new Error('Not authenticated. Call login() first.');
    }

    // The 'create' method expects the data for the new record inside an array.
    const args = [
        this.db,
        this.uid,
        this.password,
        model,
        'create',
        [data] // Note: The data object is wrapped in an array.
    ];

    try {
        const response = await fetch(`${this.url}/jsonrpc`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                jsonrpc: "2.0",
                method: "call",
                params: {
                    service: "object",
                    method: "execute_kw",
                    args: args
                },
                id: Math.floor(Math.random() * 1000000000)
            })
        });

        const result = await response.json();

        if (result.error) {
            console.error('Odoo RPC Error:', result.error);
            // Providing more detailed error info if available
            const errorMessage = result.error.data ? result.error.data.message : result.error.message;
            throw new Error(errorMessage);
        }

        // The 'create' method returns the integer ID of the newly created record
        return result.result;
    } catch (error) {
        console.error(`Error in create for model ${model}:`, error);
        throw error;
    }
    }
    /// Example program
//     async function addNewCustomer() {
//   const customerData = {
//     name: 'New Horizon Labs',
//     email: 'contact@newhorizon.test',
//     phone: '+1-555-987-6543',
//     website: 'https://newhorizon.test',
//     company_type: 'company', // Use 'person' for an individual contact
//     street: '123 Innovation Drive',
//     city: 'Techville',
//     zip: '98765',
//     country_id: 238 // Example: ID for the United States. You may need to search for the correct country ID.
//   };

//   try {
//     console.log('Creating new customer...');
//     const newCustomerId = await odoo.create('res.partner', customerData);
//     console.log(`Successfully created customer with ID: ${newCustomerId}`);
//     return newCustomerId;
//   } catch (error) {
//     console.error('Failed to create customer:', error.message);
//   }
// }

}

// Usage example:
/*
const odooService = new OdooJsonRpcService('https://mimir.xyz', 'production');

// Test connection
await odooService.getVersion();

// Authenticate
await odooService.authenticate('salasar.developer@icloud.com', 'your-password');

// Fetch products
const products = await odooService.fetchProducts();
console.log('Products:', products);

// Search products
const searchResults = await odooService.searchProducts('laptop');
console.log('Search results:', searchResults);
*/

export default OdooJsonRpcService;